<template>
  <div class="ui left aligned container">
    <div class="ui right aligned container">
      <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
    </div>
    <vuetable ref="vuetable"
              :api-url="'/episodes4?interval=' + interval"
              :fields="fields"
              :perPage="13"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://v.qq.com/x/cover/mzc00200enq74al.html" target="_blank"> 腾讯视频 </a>
      <a href="https://movie.douban.com/subject/35192154/" target="_blank"> 豆瓣电影 </a>
      <a href="https://tieba.baidu.com/f?ie=utf-8&kw=%E8%AF%B4%E8%8B%B1%E9%9B%84%E8%B0%81%E6%98%AF%E8%8B%B1%E9%9B%84" target="_blank"> 百度贴吧 </a>
      <a href="http://piaofang.maoyan.com/tv/1359652" target="_blank"> 猫眼票房 </a>
      <p v-if="playData">
        <a href="http://d.guduodata.com/m/detail_v3#show_id=24024" target="_blank">骨朵数据</a>：<br>
        今日播放量： <a href="http://data.guduodata.com/show/detail?showId=24024" target="_blank">{{playData.today_play_count}}</a>
        昨日播放量： <a href="http://data.guduodata.com/show/detail?showId=24024" target="_blank">{{playData.yesterday_play_count}}</a>
        累计播放量： <a href="http://data.guduodata.com/show/detail?showId=24024" target="_blank">{{playData.total_play_count}}</a>
      </p>
    </div>
    <div class="ui hidden divider"></div>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
            <label>5分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
            <label>15分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="30" v-model="interval" @change="load()">
            <label>30分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
            <label>1小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="180" v-model="interval" @change="load()">
            <label>3小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
    <v-chart id="chart2" :options="options2" theme="light"></v-chart>
  </div>
</template>
<style>
</style>
<script>
  import Vuetable from '../../table/Vuetable.vue'
  import VuetablePagination from '../../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'

  export default {
    name: 'Episode4',
    components: {
      Vuetable,
      VuetablePagination,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'time', title: '时间', callback: 'localTime'},
          {name: 'txPlay', title: '腾讯播放量'},
          {name: 'txScore', title: '腾讯评分'},
          {name: 'todayPlay', title: '骨朵今日播放量'},
          {name: 'totalPlay', title: '骨朵总播放量'},
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        interval: 5,
        page: 0,
        options: null,
        options2: null,
        playData: null,
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        axios.get('/episodes4/data').then(({data}) => {
          this.playData = data;
        });
        let page = Math.floor(this.page * 5 / this.interval);

        axios.get('/episodes4/chart?size=13&page=' + page + '&interval=' + this.interval).then(response => {
          this.options =
              {
                title: {
                  text: '增幅(万)'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['腾讯播放量增长', '播放量增长']
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: '腾讯播放量增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, e.txInc])
                  },
                  {
                    name: '播放量增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, Number(e.txInc).toFixed(1)])
                  },
                ]
              };
          this.options2 =
            {
              title: {
                text: '播放量(万)'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['腾讯播放量', '骨朵今日播放量']
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '腾讯播放量',
                  type: 'line',
                  data: response.data.map(e => [e.time, this.toNumber(e.txPlay)])
                },
                {
                  name: '骨朵今日播放量',
                  type: 'line',
                  data: response.data.map(e => [e.time, this.toNumber(e.todayPlay)])
                },
              ]
            };
        });
      },
      refresh: function () {
        this.$refs.vuetable.reload();
        this.load();
      },
      localTime (value) {
        return new Date(value).toLocaleString()
      },
      total(value, row) {
        let txPlay = this.toNumber(row['txPlay']);
        return this.toText(txPlay);
      },
      toNumber(text) {
        if (text.includes("亿")) {
          return +text.replace('亿', '') * 10000;
        }
        return +text.replace('万', '');
      },
      toText(num) {
        if (num >= 10000) {
          return (num / 10000).toFixed(2) + '亿';
        }
        return num.toFixed(1) + '万';
      }
    }
  }
</script>
